import Vue from 'vue';
import VueRouter from 'vue-router';
import Layout from '../layout/index.vue';

import control from '../components/control.vue';
import deviceList from '../components/DeviceList.vue';
import channelList from '../components/channelList.vue';
import pushVideoList from '../components/PushVideoList.vue';
import streamProxyList from '../components/StreamProxyList.vue';
import devicePosition from '../components/devicePosition.vue';
import login from '../components/Login.vue';
import parentPlatformList from '../components/ParentPlatformList.vue';
import cloudRecord from '../components/CloudRecord.vue';
import mediaServerManger from '../components/MediaServerManger.vue';
import web from '../components/setting/Web.vue';
import sip from '../components/setting/Sip.vue';
import media from '../components/setting/Media.vue';
import live from '../components/live.vue';
import historicalAlarm from '../components/historicalAlarm.vue';
import role from '../components/Role.vue';
import user from '../components/User.vue';
import dept from '../components/dept.vue';
import shipManage from '../components/shipManage.vue';
import videoManage from '../components/videoManage.vue';
import alarmManage from '../components/alarmManage.vue';
import deviceTree from '../components/common/DeviceTree.vue';
import shipPosition from '@/components/shipPosition.vue';

import wasmPlayer from '../components/common/jessibuca.vue';
import rtcPlayer from '../components/dialog/rtcPlayer.vue';

const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err);
};

Vue.use(VueRouter);

export default new VueRouter({
  mode: 'hash',
  routes: [
    {
      path: '/',
      name: 'home',
      component: Layout,
      redirect: '/live',
      children: [
        {
          path: '/control',
          component: control
        },
        {
          path: '/live',
          component: live,
          meta: {
            keepAlive: true
          }
        },
        {
          path: '/historicalAlarm',
          component: historicalAlarm
        },
        {
          path: '/deviceList',
          component: deviceList
        },
        {
          path: '/pushVideoList',
          component: pushVideoList
        },
        {
          path: '/role',
          component: role
        },
        {
          path: '/dept',
          component: dept
        },
        {
          path: '/shipManage',
          component: shipManage
        },
        {
          path: '/user',
          component: user
        },
        {
          path: '/videoManage',
          component: videoManage
        },
        {
          path: '/alarmManage',
          component: alarmManage
        },
        {
          path: '/streamProxyList',
          component: streamProxyList
        },
        {
          path: '/channelList/:deviceId/:parentChannelId/:count/:page',
          name: 'channelList',
          component: channelList
        },
        {
          path: '/parentPlatformList/:count/:page',
          name: 'parentPlatformList',
          component: parentPlatformList
        },
        {
          path: '/devicePosition/:deviceId/:parentChannelId/:count/:page',
          name: 'devicePosition',
          component: devicePosition
        },
        {
          path: '/cloudRecord',
          name: 'cloudRecord',
          component: cloudRecord
        },
        {
          path: '/mediaServerManger',
          name: 'mediaServerManger',
          component: mediaServerManger
        },
        {
          path: '/setting/web',
          name: 'web',
          component: web
        },
        {
          path: '/setting/sip',
          name: 'sip',
          component: sip
        },
        {
          path: '/setting/media',
          name: 'media',
          component: media
        },
        {
          path: '/managementInterface',
          name: 'managementInterface',
          component: () => import('@/components/managementInterface.vue')
        },
        {
          path: '/map',
          name: 'devicePosition',
          component: devicePosition
        },
        {
          path: '/shipPosition',
          name: 'shipPosition',
          component: shipPosition
        }
      ]
    },
    {
      path: '/login',
      name: '登录',
      component: login
    },
    {
      path: '/test',
      name: 'deviceTree',
      component: deviceTree
    },
    {
      path: '/play/wasm/:url',
      name: 'wasmPlayer',
      component: wasmPlayer
    },
    {
      path: '/play/rtc/:url',
      name: 'rtcPlayer',
      component: rtcPlayer
    }
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js